import { z } from 'zod';
import { envelope, IdString, Platform } from './common.js';

export const ShopConnection = z.object({
  id: IdString,
  platform: Platform,
  shopId: z.string(),
  shopName: z.string(),
  region: z.string().nullable(),
  sellerName: z.string().nullable(),
  status: z.enum(['CONNECTED', 'REAUTH_REQUIRED', 'REVOKED']),
  accessExpiresAt: z.string(),
  refreshExpiresAt: z.string().nullable(),
  connectedBy: z.string(),
  connectedAt: z.string(),
  lastRefreshedAt: z.string().nullable(),
  lastError: z.string().nullable(),
});
export type ShopConnection = z.infer<typeof ShopConnection>;

export const PlatformSetup = z.object({
  /** App đã có khóa (app key/secret, partner_id) trên máy chủ. */
  configured: z.boolean(),
  /** Người dùng hiện tại bấm kết nối được không, và lý do nếu không. */
  canConnect: z.boolean(),
  reason: z.string().nullable(),
  /** URL callback cần khai báo ở trang nhà phát triển của sàn (chỉ trả cho quản trị). */
  redirectUri: z.string().nullable(),
});
export type PlatformSetup = z.infer<typeof PlatformSetup>;

export const IntegrationsResponse = envelope(
  z.object({
    platforms: z.object({ tiktok: PlatformSetup, shopee: PlatformSetup }),
    connections: z.array(ShopConnection),
  }),
);
export type IntegrationsResponse = z.infer<typeof IntegrationsResponse>;

export const AuthorizeRequest = z.object({ entity: IdString });
export const AuthorizeResponse = envelope(z.object({ url: z.url() }));
export type AuthorizeResponse = z.infer<typeof AuthorizeResponse>;
